import React from 'react';
import { translate } from '../../services';
import { PropTypes } from 'prop-types';
import { getProductLink } from '../../util';
import { Typography } from '@mui/material';

const ProductCodeComponent = ( { aliases, name, code, productLink, superCode,configurableProduct,materialName,_accessory,superCodeLSO,accessorylength} ) => { 
  const link = productLink || getProductLink( name,superCode,configurableProduct );
 // let codes = superCode ? superCode + ' - ' + code : code; for CN only lso to be used

 let codes = accessorylength>0?superCodeLSO? superCodeLSO: code:code;

  const acc_code=_accessory?.name;
  if( aliases ){
    codes += aliases.usConCode && aliases.usConCode !== code ? `( ${aliases.usConCode} )` : '';
    codes += aliases.superCode && aliases.superCode !== code ? `( ${aliases.superCode} )` : '';
  }
  
  let code1 = ""
  let code2 = ""

  if(codes?.includes("+")){
    code1 = codes.split("+")[0];
    code2 = codes.split("+")[1];
  }
if(materialName=='MB_VD4_D' || (acc_code!=undefined && acc_code.indexOf("ACC_VD4")>-1)|| code?.startsWith('V')){
    return <h4 className="product-code ellipsed" title={ translate( 'Open detailed information' ) }>
    <div>{ codes }</div>
  </h4>}
  return <a href={ link } target="_blank">
    <span className="product-code ellipsed" title={ translate( 'Open detailed information' ) }>
      {codes?.includes("+")?<div style={{display:"flex", flexDirection:"column"}}>
        <span className="product-code ellipsed">{code1}</span>
        <span className="product-code ellipsed">{"+"}</span>
        <span className="product-code ellipsed">{code2}</span>
      </div>:<div>{ codes }</div>}
    </span>
  </a>;
};

ProductCodeComponent.propTypes = {
  aliases: PropTypes.shape( {
    superCode: PropTypes.string,
    usConCode: PropTypes.string
  } ),
  name: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  productLink: PropTypes.string
};

export const ProductCode = ProductCodeComponent;